import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { updateCampaignState, updateVideoPageState } from "../../VideoActions";

const CampaignBreadcrumbs = () => {
  const dispatch = useDispatch();
  const campaignBreadcrumbs = useSelector(
    state => state.videoPageStates.campaignsState.breadcrumbs
  );
  const navigate = useNavigate();

  const arr = [];

  campaignBreadcrumbs.forEach((i, index) => {
    arr.push(
      <div key={`icon-${index}`}>
        <img
          src={require("@images/videos/expand-right-icon.png").default}
          width={9}
          alt="expand right icon"
        />
      </div>
    );
    arr.push(
      <div
        key={`breadcrumb-${index}`} 
        className={`BreadCrumbTitle ${i.type === "link" || i.type === "tab" ? "ActivePage" : "ActiveTab"}`}
        onClick={() => {
          navigate(i.link);

          if (i.page === "videos") {
            dispatch(updateVideoPageState({
              isCategoryPage: false,
              isCampaignListPage: true,
            }));
            dispatch(updateCampaignState({
              breadcrumbs: [],
              showCampaignHeader: false,
            }));
          }
        }}
      >
        {i.name}
      </div>
    );
  });

  return (
    <div className="IndexPageBreadCrumb">
      <div className="BreadCrumbContainer">{arr}</div>
    </div>
  );
};

export default CampaignBreadcrumbs;
